import Link from "next/link";
import { useState } from "react";
import { AiOutlineClose, AiOutlineDown } from "react-icons/ai";
import styled from "styled-components";
import { menuItems, menuList } from "../../../static/menuList";
import Container from "../Container";
import Logo from "./Logo";

const MobileSubMenu = ({ show, closeMobileSubMenu }) => {
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const subMenuItems = activeMenuItem && menuList(activeMenuItem);

  return (
    show?
    <Wrapper className={`fixed top-0 w-full h-full overflow-hidden left-0 bg-white z-50 ${show ? "active" : ""}`}>
      <div className="bg-accent py-2">
        <Container>
          <div className="flex justify-between items-center pb-3">
            <div>
              <Logo />
            </div>

            <AiOutlineClose className="h-8 w-8" onClick={() => closeMobileSubMenu()} />
          </div>
        </Container>
      </div>

      <div className={"h-full overflow-y-auto"}>
        <div className="pb-6">
          {menuItems.map((item, index) => (
            <div key={item.key}>
              <div
                className={`grid grid-cols-12 py-6 items-center  px-6 ${index % 2 !== 0 ? "bg-main text-white" : "bg-gray-50"}`}
                onClick={() => !item.href.length && setActiveMenuItem(activeMenuItem === item.key ? null : item.key)}>
                <div className="col-span-8 font-medium text-xl">
                  {item.href.length ? (
                    <Link href={item.href} target="_blank" rel="noreferrer">
                      {item.label}
                    </Link>
                  ) : (
                    <h3>{item.label}</h3>
                  )}
                </div>

                {!item.href.length && (
                  <div className="col-span-4 ml-auto">
                    <AiOutlineDown className="inline-block h-6 w-6" />
                  </div>
                )}
              </div>

              <div className={`${activeMenuItem === item.key ? "block" : "hidden"}`}>
                {subMenuItems &&
                  subMenuItems.map((subItem) => (
                    <div className="px-6 mt-2 pb-3" key={subItem.label}>
                      <h4 className="mb-2">
                        <Link href={""} className="text-lg font-medium text-main">
                          {subItem.label}
                        </Link>
                      </h4>

                      <div className="space-y-4 mt-4">
                        {subItem.list.map((individualItem) => (
                          <Link className="block" href={individualItem.url} target="_blank">
                            {individualItem.label}
                          </Link>
                        ))}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Wrapper>
:null
  );
};

export default MobileSubMenu;

const Wrapper = styled.div`
  left: -100vw;
  transition: all 0.4s ease-in;

  &.active {
    visibility: visible;
    left: 0;
    transition: all 0.5s ease-in;
  }
`;
